import request from '../../../shared/request'

export function getRelatedLeadEstimates(job_id) {
  return request(`/job/purchase_order/related_estimates/${job_id}/`)
}

export function getEstimate(estimateId) {
  return request(`/job/purchase_order/estimate/${estimateId}/`)
}



// WEBPACK FOOTER //
// ./src/redux/api/job/purchaseOrders.js